/**
 * This is the Food Diary pie chart empty state
 * Sets 1 to element 1 of array
 * Allows pretty cool animation
 */
import numeral from 'numeral'
import {Doughnut} from 'vue-chartjs/dist/vue-chartjs'
export default {
  extends: Doughnut,
  name: 'food-pie-empty',
  props: {
    calories: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: "kcal"
    }
  },
  mounted() {
    let self = this;
    self.addPlugin({
      id: 'pieLabel',
      beforeDraw: function (chart) {
        const width = chart.chart.width, height = chart.chart.height, ctx = self.$refs.canvas.getContext("2d");
        ctx.restore();
        const fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#333";
        const number = numeral(self.calories.toFixed(2));
        const text = `${number.format('0,0')}${self.unit}`,
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
    self.render();
  },
  methods: {
    render() {
      let self = this;
      self.renderChart({
        labels: [
          this.$t('message.nutrientFat')
        ],
        datasets: [
          {
            backgroundColor: [
              '#DEDCE2'
            ],
            data: [1]
          }
        ]
      }, {
        legend: false,
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        percentageInnerCutout: 24,
        hover: {mode: null},
        tooltips: {
          enabled: false
        },
        plugins: {
          pieLabel: true
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FoodDiary/Graphs/PieEmpty/empty.js